import { render, staticRenderFns } from "./SolanJournalsTTableProjectRow.vue?vue&type=template&id=dd691386&scoped=true&"
import script from "./SolanJournalsTTableProjectRow.vue?vue&type=script&lang=ts&"
export * from "./SolanJournalsTTableProjectRow.vue?vue&type=script&lang=ts&"
import style0 from "./SolanJournalsTTableProjectRow.vue?vue&type=style&index=0&id=dd691386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd691386",
  null
  
)

export default component.exports